import { render, staticRenderFns } from "./getAppliedCourse.vue?vue&type=template&id=1372fd20&xmlns%3Acolor=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./getAppliedCourse.vue?vue&type=script&lang=js&"
export * from "./getAppliedCourse.vue?vue&type=script&lang=js&"
import style0 from "./getAppliedCourse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports